define('formatPrice',['string','app','hooks','underscore'],function (S,app,hooks,_) {
    var defaultFormat = {};
    return function(value, format){
        var v = parseFloat(value),
            currency = app.getCurrency(),
            sign = currency.getSign(),
            space = ' ', // no break space
            // position du symbole monaitaire
            // left (default) : gauche
            // right : droite
            // none : masque
            signPosition = app.c('_SIGN_CURRENCY_POSITION_'), //
            negativePosition = app.c('_NEGATIVE_AMOUNT_CURRENCY_POSITION_','before-currency'), //
            //
            decimals = currency.getDecimals(), // 2
            decimalsFactor = Math.pow(10,decimals),
            decimalsSeparator = app.c('_DECIMALS_CURRENCY_SEPARATOR_',','); // séparateur des décimales (virgule)

        format = format ? _(format).defaults(defaultFormat) : defaultFormat;

        hooks.execHook('formatPriceModifier',{v:v,sign:sign,currency:currency},function(modifier){
            v = modifier.v;
            sign = modifier.sign;
        });

        if(format.auto_round_decimal && (v%1 === 0)){
            decimalsFactor = 1;
            decimals = 0;
        }

        if(format.wrap_sup){
            sign = "<sup>"+sign+"</sup>";
        }

        if(format.ignore_space){
            space = "";
        }

        v = Math.round(v*decimalsFactor)/decimalsFactor;

        return _.isNaN(v) ? '' : v.toString().replace(/^(-)?([0-9]+).?([0-9]*)$/g,function(match,minus,right,left) {

            var n = right+(decimals==0?'':decimalsSeparator+S(left).padRight(decimals,'0')),
                s = sign,
                __ = space;
            if(minus){
                switch(negativePosition){
                    case 'before-sign':
                        s = minus+s;
                        break;
                    case 'before-currency':
                    default :
                        n = minus+n;
                }
            }
            switch(signPosition){
                case 'left': default :
                    n = s+__+n;
                    break;
                case 'right':
                    n = n+__+s;
                    break;
                case 'none':
                    break;
            }
            return n;
        });
    };
});
